// CUSTOM JS TO APPLY ONLY TO INDEX PAGE
$(function(){
    // MODAAL & ANIMATION
    var $scrollBar = $(".scrollbar");
    var $scrollText = $(".scrollbar-text");
    var $pagetopBar = $(".pagetopbar");
    var $pagetopText = $(".pagetopbar-text");
    var $movieModaal = $(".oki-movie");

    // スクロール量に応じた処理
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();
    var $scrollWrapper = $(".scroll-element");
    var $aboutWrapper = $(".fadein-content");
    var $collectionWrapper = $("#oki-content");
    if(windowWidth < 767){
        var indexCollectionPosition = 0;
    }else{
        var indexCollectionPosition = $collectionWrapper.offset().top - windowHeight -200;
    }

    var initScroll = $(window).scrollTop()
    if(windowWidth < 767){
        var y = window.pageYOffset;
        setTimeout(() => {
            if(y >= 0 && y <= indexCollectionPosition){
                $aboutWrapper.fadeIn();
            }
        }, 10);
    }else{
        if(initScroll < indexCollectionPosition ){
            $aboutWrapper.fadeIn();
        }else{
            $aboutWrapper.fadeOut();
        }
    }

    $(window).scroll(function() {
        // ページのスクロール量を取得
        var scroll = $(this).scrollTop();
        if(scroll >= 0 && scroll <= indexCollectionPosition){
            $aboutWrapper.fadeIn();
        }else{
            if(windowWidth < 767){
                $aboutWrapper.hide();
            }else{
                $aboutWrapper.fadeOut();
            }
        }
        // スクロールバー Fadeout
        if (scroll >= 5) {
            $scrollBar.removeAttr("style");
            $scrollText.removeAttr("style");
        } else {
            $scrollBar.css('opacity', 1).css('transform', 'translate(0, 0)');
            $scrollText.css('opacity', 1).css('transform', 'translate(0, 0) rotate(90deg)');
        }
        // スクロールバー Fadeout
        if (scroll <= 1000) {
            $pagetopBar.removeAttr("style");
            $pagetopText.removeAttr("style");
        } else {
            $pagetopBar.css('opacity', 1);
            $pagetopText.css('opacity', 1);
        }

    });

    // Smoothscroll
    $('a.scroll-bar-jquery').click(function(){
        var speed = 800;
        var position = windowHeight * 1.5;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });
    $('a.pagetop-bar-jquery').click(function(){
        var speed = 800;
        $("html, body").animate({scrollTop:0}, speed, "swing");
        return false;
    });

    // RELLAX
    var rellax = new Rellax('.rellax');

    // MODAAL
    $movieModaal.modaal({
        custom_class: "oki-movie-modaal"
    });
});